<template>
  <div class="transfer-content">
    <div class="left">
      <div class="left-t">
        <el-input :placeholder="placeholder" v-model="searchValue" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="left-c">
        <el-tree
          ref="tree"
          node-key="id"
          :data="treeList"
          :props="defaultProps"
          :highlight-current="false"
          :default-expand-all="true"
          :expand-on-click-node="expandOnClickNode"
          @node-click="handleNodeClick"
          :filter-node-method="filterNode"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span>{{ node.label }}</span>
            <i v-if="node.checked == true" class="el-icon-success"></i>
          </span>
        </el-tree>
      </div>
    </div>
    <i class="el-icon-d-arrow-right"></i>
    <div class="right">
      <div class="right-t">
        <div>{{rightTitle}}（{{chooseList.length}}）</div>
        <div v-if="chooseList.length" class="right-b" @click="handleNodesDelete">清空</div>
      </div>
      <div class="right-c">
        <el-empty v-if="chooseList.length <= 0" description="暂无数据"></el-empty>
        <div v-else>
          <div v-for="(item, index) in chooseList" :key="index">
            <div class="right-item">
              <el-tooltip
                class="right-text"
                effect="dark"
                :open-delay="500"
                :content="item[filterKey]"
                placement="top"
              >
                <div>{{item[filterKey]}}</div>
              </el-tooltip>
              <div @click="handleNodeDelete(item)" class="el-icon-error"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'treeTransfer',
  props: {
    chooseList: {
      type: Array,
      default: () => [],
    },
    rightTitle: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请输入',
    },
    defaultRxpandAll: {
      type: Boolean,
      default: false,
    },
    expandOnClickNode: {
      type: Boolean,
      default: true,
    },
    filterKey: {
      type: String,
      default: 'label',
    },
  },
  data() {
    return {
      searchValue: '',
      defaultProps: {
        children: 'children',
        label: 'deptName',
      },
    }
  },
  computed:{
    ...mapState({treeList: state=>state.system.deptTreeList})
  },
  watch: {
    searchValue: function (val) {
      this.$refs.tree.filter(val)
    },
    chooseList: {
      deep: true,
      handler(newVal) {
        if (this.$refs.tree) {
          for (var i = 0; i < newVal.length; i++) {
            const data = newVal[i]
            this.handleNodeCheck(data, true)
          }
        }
      },
    },
  },
  methods: {
    handleNodeClick(data) {
      this.handleNodeCheck(data, true)
      this.$emit('on-tree', data)
    },
    handleNodeDelete(data) {
      this.handleNodeCheck(data, false)
      this.$emit('on-delete', data)
    },
    handleNodesDelete() {
      for (var i = 0; i < this.chooseList.length; i++) {
        const data = this.chooseList[i]
        this.handleNodeCheck(data, false)
      }
      this.$emit('on-delete')
    },
    handleNodeCheck(data, checkState) {
      const node = this.$refs.tree.getNode(data.id)
      if (node) {
        node.checked = checkState
      }
    },
    filterNode(value, data) {
      if (!value) return true
      return data[this.filterKey].indexOf(value) !== -1
    },
  },
}
</script>

<style lang='less' scoped>
@import '~@/assets/variables.less';
.transfer-content {
  display: flex;
  justify-content: space-between;
  height: 250px;
  .el-icon-error {
    color: #f56c6c;
    font-size: 18px;
  }
  .el-icon-success {
    color: @theme-color;
    font-size: 18px;
  }
  .el-icon-d-arrow-right:before {
    top: 50%;
    left: 46%;
    position: absolute;
    transform: translate(-50%, -50%);
  }
  .left {
    width: 44%;
    border-radius: 5px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    overflow: hidden;
    .left-t {
      height: 40px;
      line-height: 40px;
      box-sizing: content-box;
      border-bottom: 1px solid #dcdfe6;
    }
    .left-c {
      height: 210px;
      padding: 0 10px;
      overflow: auto;
    }
  }
  .right {
    width: 52%;
    border-radius: 5px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    overflow: hidden;
    .right-t {
      height: 40px;
      line-height: 40px;
      box-sizing: content-box;
      border-bottom: 1px solid #dcdfe6;
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .right-b {
        cursor: pointer;
      }
    }
    .right-c {
      height: 210px;
      padding: 0 10px;
      overflow: auto;
      .right-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 30px;
        cursor: pointer;
        .right-text {
          width: 90%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}
// 滚动条样式
/* scrollbar style start */
::v-deep {
  .el-input {
    .el-input__inner {
      height: 40px;
      border: none;
    }
  }
  .el-tree {
    height: 100%;
  }
  .el-empty {
    height: 100%;
    padding: 0;
    .el-empty__image {
      display: none;
    }
    .el-empty__description {
      margin-top: 0;
    }
  }
  ::-webkit-scrollbar {
    width: 10px !important;
    height: 10px !important;
    background: transparent;
  }
}
</style>
